import React from 'react';

interface DocumentoVencidoAvisoProps {
  nombre?: string | null;
  alerta: string;
}

export const DocumentoVencidoAviso: React.FC<DocumentoVencidoAvisoProps> = ({ nombre, alerta }) => (
  <div className="w-full">
    <span className="inline-flex items-center gap-1.5 text-red-700 text-xs font-medium">
      <span className="text-red-600 text-base leading-none" aria-hidden="true">⚠</span>
      <span className="truncate max-w-[180px] text-red-700">{nombre || 'Documento'}</span>
      <span className="text-[10px] text-red-800 bg-red-100 border border-red-300 rounded px-1 shrink-0">vencido</span>
    </span>
    <p role="alert" className="mt-1 text-[11px] leading-snug text-red-800 bg-red-50 border border-red-200 rounded px-2 py-1">
      {alerta}
    </p>
  </div>
);
